// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"342":"b0a1a920","862":"ad6d93dc"}[chunkId] + ".chunk.css";
};